import React from 'react';
import { SVGProps } from './type';

const Icon = ({ fill }: SVGProps) => (
  <g>
    <path
      xmlns="http://www.w3.org/2000/svg"
      fillRule="evenodd"
      clipRule="evenodd"
      transform="scale(1.2 1.2)"
      d="M8.90882 7.11052C8.89025 7.13091 8.8718 7.15152 8.85347 7.17235L8.85345 7.17233L8.84885 7.17764L8.13335 8.0046L7.41784 7.17764C5.70467 5.19762 2.83818 5.19762 1.12501 7.17764L0.647461 7.72959L1.12501 8.28153L4.97527 12.7315C5.82131 13.7094 6.96188 14.2409 8.14581 14.2098C9.30836 14.2061 10.4367 13.6867 11.2821 12.7422L11.2868 12.7369L11.2914 12.7315L11.9956 11.9176L12.6999 12.7315C14.413 14.7115 17.2795 14.7115 18.9927 12.7315L19.4702 12.1796L18.9927 11.6276L15.1424 7.17764C14.287 6.18895 13.144 5.69394 12.0006 5.69263C10.8803 5.69134 9.75971 6.16398 8.90882 7.11052ZM9.48715 9.01836L8.77126 9.84577L8.13335 10.5831L7.49543 9.84577L6.14201 8.28153C5.26698 7.2702 3.95326 7.10949 2.93881 7.7994L6.2511 11.6276C6.80216 12.2645 7.47664 12.5418 8.10836 12.5231L8.12085 12.5227H8.13335C8.78476 12.5227 9.46958 12.2349 10.0205 11.622L10.8802 10.6284L9.48715 9.01836ZM13.1111 10.6284L13.9757 11.6276C14.8507 12.639 16.1645 12.7997 17.1789 12.1098L14.5041 9.01837L13.1111 10.6284ZM13.3282 7.79907L11.9957 9.33916L10.6658 7.80221C11.0809 7.52086 11.5409 7.38043 11.9993 7.37973C12.4587 7.38039 12.9179 7.52017 13.3282 7.79907Z"
      fill={fill}
    />
  </g>
);

export default Icon;
